import { inheritsLoose as _inheritsLoose, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var _excluded = ["handleMouseLeave", "handleMouseOver"];

// eslint-disable-next-line zillow/react/prefer-stateless-function
var Bar = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Bar, _Component);
  function Bar() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Bar.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      handleMouseLeave = _this$props.handleMouseLeave,
      handleMouseOver = _this$props.handleMouseOver,
      props = _objectWithoutProperties(_this$props, _excluded);
    return /*#__PURE__*/React.createElement("rect", _extends({
      className: "rd3-barchart-bar"
    }, props, {
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    }));
  };
  return Bar;
}(Component);
Bar.defaultProps = {
  fill: 'blue'
};
Bar.propTypes = process.env.NODE_ENV !== "production" ? {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  handleMouseOver: PropTypes.func,
  handleMouseLeave: PropTypes.func
} : {};

export { Bar };
